import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { LoadingCell } from '@mint-lib/ag-grid/components';
import { useTranslation } from '@mint-lib/i18n';

import { LOADING_STATE } from '../../../../consts/flights.js';
import { FLIGHT_TOTAL_ROW_ID } from '../../../../types/flights.types.js';

const FlightTextRenderer = (params: CustomCellRendererProps) => {
  const { t } = useTranslation('@myn/planning_v2');

  const isCellLoading = params.data.id === LOADING_STATE;
  const isTotalsLoading =
    params.data.id === FLIGHT_TOTAL_ROW_ID && params.value === LOADING_STATE;

  if (isCellLoading || isTotalsLoading) {
    return <LoadingCell />;
  }

  if (!params.value && params.colDef?.editable) {
    return (
      <span className="flex justify-end text-text-placeholder">
        {t('Insert')}
      </span>
    );
  }

  return <span>{params.value}</span>;
};

export default FlightTextRenderer;
